<template>
  <van-popup 
    class="wap-popup"
    v-model:show="state.visible" 
    ref="popupRef"
    :position="position" 
    :round="round" 
    :overlay="showLayer" 
    :teleport="teleport"
    :lazyRender="lazyRender"
    @closed="onBack"
    @opened="opened"
  >
    <slot name="head" v-if="title">
      <div class="popup-head">
        <div class="title">
          <svg-icon class="left-icon" v-if="leftIcon" @click="onBack" :name="leftIcon"/>
          <p :class="`text-${titlePosition}`">{{ title }}</p>
          <div class="right-icon" v-if="slots.rightIcon">
            <slot name="rightIcon"></slot>
          </div>
        </div>
        <slot name="insertHead"></slot>
      </div>
    </slot>
    <div class="popup-container" :style="{
      height: offsetTop,
    }">
      <slot></slot>
    </div>
    <template v-if="needFoot">
      <slot name="foot">
        <div class="popup-foot">
          <p @click="onCancel">{{ $t('cancel') }}</p>
          <p @click="onSubmit">{{ $t('submit') }}</p>
        </div>
      </slot>
    </template>
  </van-popup>
</template>
<script setup>
import { ref, watch, computed, reactive, useSlots, nextTick } from 'vue'
  

  const slots = useSlots()
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'bottom'
    },
    round: {
      type: Boolean,
      default: true
    },
    showLayer: {
      type: Boolean,
      default: true
    },
    confirmCallBack: {
      type: Function
    },
    cancelCallBack: {
      type: Function
    },
    needFoot: {
      type: Boolean,
      default: false
    },
    teleport: {
      type: String,
      default: ''
    },
    lazyRender: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    titlePosition: {
      type: String,
      default: 'center'
    },
    leftIcon: {
      type: String,
      default: ''
    },
    offsetTop: {
      type: String,
    },
    onBack: {
      type: Function,
      default: null
    },
    afterOpen: {
      type: Function,
      default: null
    }
  })

  const emit = defineEmits(['update:modelValue', 'opened', 'closed'])

  const popupRef = ref(null)

  const state = reactive({
    visible: false
  })

  const offsetTop = computed(() => {
    return props.offsetTop ? `calc(100vh - var(--browser-address-bar, 0px) - ${props.offsetTop} - var(--orbit-nav-height, 0px)` : ''
  })

  const onSubmit = () => {
    if (typeof(props.confirmCallBack) === 'function' && props.confirmCallBack) {
      props.confirmCallBack()
    } else {
      state.visible = false
    }
  }
  const onCancel = () => {
    if (typeof(props.cancelCallBack) === 'function' && props.cancelCallBack) {
      props.cancelCallBack()
    } else {
      state.visible = false
    }
  }

  const onBack = () => {
    if (props.onBack) {
      props.onBack()
    }
    state.visible = false
    emit('closed')
  }

  const opened = () => {
    if (props.afterOpen) {
      props.afterOpen()
    }
    emit('opened')
  }

  watch(props, (val) => {
    state.visible = val.modelValue
  })

  watch(() => state.visible, (val) => {
    emit('update:modelValue', val)
  })


  defineExpose({
    popupRef
  })
</script>
<style lang="postcss" scoped>
.popup-container {
  width: 100vw;
  box-sizing: border-box;
}
.popup-head {
  position: sticky;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  width: 100%;
  top: 0px;
  left: 0;
  padding: 20px 20px 4px;
  box-sizing: border-box;
  background-color: var(--background-selection);
  z-index: 2000;
  .title {
    width: 100%;
    p {
      
      line-height: 48px !important;
      font-family: 'orbit-M';
      font-size: 18px;
    }
    .text-left {
      width: calc(100% - 39px);
      text-align: left;
      padding-left: 39px;
    }
    .text-center {
      text-align: center;
    }
    .svg-icon {
      width: 24px;
      height: 48px;
    }
    .left-icon {
      position: absolute;
      left: 20px;
      top: 20px;
    }
    .right-icon {
      display: flex;
      align-items: center;
      position: absolute;
      right: 20px;
      top: 20px;
      width: 24px;
      height: 48px;
    }
  }
}
.popup-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 58px;
  p {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  p:last-child {
    color: var(--theme);
  }
}
</style>
<style lang="postcss">
 

.wap-popup {

  .van-popup--right.van-popup--round {
    border-radius: var(--van-popup-round-radius) var(--van-popup-round-radius) 0 0;
  }
    
  .van-popup--right {
    top: unset;
    bottom: 0;
    transform: translate(0, 0);
  }
}
</style>